import { createSelector } from '@ngrx/store';
import { Venue } from '../../../models';
import { AppState } from '../app.state';

export const selectVenue = createSelector(
  (state: AppState) => state.venue,
  (venue: Venue) => venue
);
